/**
 * Strip HTML tags from content (for safe text-only display in snippets/excerpts)
 * and truncate to a given length with an ellipsis.
 */
export function getArticleSnippet(content, maxLength = 110) {
  if (!content) return '';
  // Remove HTML tags + decode common entities + collapse whitespace
  const text = content
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/\s+/g, ' ')
    .trim();
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength).trimEnd() + '...';
}
